import { FilterCompTypes } from 'app/ComponentLibrary/Filter/utils';
import { addDays, endOfDay, startOfDay } from 'date-fns';
import { getAmnEndOfWeek, getAmnStartOfWeek } from 'utils/dates/dateExtraction';
import { PLACEMENT_MODS_CONSTANTS } from '../CommonComponents/Utils';

export enum PlacementHistoryFilterName {
  modType = 'modType',
  approvalStatus = 'approvalStatus',
  acceptanceStatus = 'acceptanceStatus',
  recruiterApproved = 'recruiterApproved',
  voidStatus = 'voidStatus',
  effectiveDate = 'effectiveDate',
  activeMods = 'activeMods',
}

export interface IPlacementHistoryFilters {
  modType?: string;
  approvalStatus?: string;
  acceptanceStatus?: string;
  recruiterApproved?: string;
  voidStatus?: string;
  endDate?: any;
  startDate?: any;
  activeMods?:string;
}

export const modTypeOptions = [
  { id: 0, name: 'All', value: 'All' },
  { id: 1, name: 'Bonus', value: 'Bonus' },
  { id: 2, name: 'EMI/LMO', value: 'EMI/LMO' },
  { id: 3, name: 'Furniture', value: 'Furniture' },
  { id: 4, name: 'Housing', value: 'Housing' },
  { id: 5, name: 'Insurance', value: 'Insurance' },
  { id: 6, name: 'Pay Rate', value: 'Pay Rate' },
  { id: 8, name: 'Time off', value: 'Time off' },
  { id: 9, name: 'WKS/PTS', value: 'WKS/PTS' },
  { id: 10, name: 'Start Date', value: 'Start Date' },
  { id: 11, name: 'End Date', value: 'End Date' },
  { id: 12, name: 'Reimbursement', value: 'Reimbursement' },
  { id: 13, name: 'Bill Rate', value: 'Bill Rate' },
  { id: 14, name: 'Preferences', value: 'Preferences' },
  { id: 15, name: 'Interim Travel', value: 'Interim Travel' },
  { id: 16, name: 'Arriving Travel', value: 'Arriving Travel' },
  { id: 17, name: 'Ending Travel', value: 'Ending Travel' },
  { id: 18, name: 'Payroll Shift Differential', value: 'Payroll Shift Differential' },
  { id: 19, name: 'Billing Shift Differential', value: 'Billing Shift Differential' },
  { id: 20, name: 'Lodging Per Diem Adjustment', value: 'Lodging Per Diem Adjustment' },
  { id: 21, name: 'Min. Req. Hours', value: 'Min. Req. Hours' },
  { id: 22, name: 'Shift', value: 'Shift' },
  { id: 23, name: 'PTO', value: 'PTO' },
  { id: 24, name: "OGP Int'l Loan", value: "OGP Int'l Loan" },
].sort(function (a, b) {
  if (a.name < b.name) {
    return -1;
  }
  if (a.name > b.name) {
    return 1;
  }
  return 0;
});

export const approvalStatusOptions = [
  { id: 2, name: 'Approved', value: 'Approved' },
  { id: 3, name: 'Denied', value: 'Denied' },
];

export const acceptanceStatusOptions = [
  { id: 1, name: 'Accepted', value: 'Accepted' },
  { id: 2, name: 'Declined', value: 'Declined' },
];

export const recruiterApprovedOptions = [
  { id: 1, name: 'No', value: 'N', labelPrefix: 'Recruiter Approved' },
  { id: 2, name: 'Yes', value: 'Y', labelPrefix: 'Recruiter Approved' },
];

export const voidStatusOptions = [
  { id: 1, name: 'No', value: 'N', labelPrefix: 'Void' },
  { id: 2, name: 'Yes', value: 'Y', labelPrefix: 'Void' },
];
export const activeModsOptions = [
  { id: 1, name: 'Active Only', value: PLACEMENT_MODS_CONSTANTS.CURRENT },
];

export const defaultPlacementHistoryFilters = {
  [PlacementHistoryFilterName.modType]: null,
  [PlacementHistoryFilterName.approvalStatus]: null,
  [PlacementHistoryFilterName.acceptanceStatus]: null,
  [PlacementHistoryFilterName.recruiterApproved]: null,
  [PlacementHistoryFilterName.voidStatus]: null,
  [PlacementHistoryFilterName.effectiveDate]: null,
  [PlacementHistoryFilterName.activeMods]: null,
};

export const getPlacementHistoryFilters = (t,isFilterDisabled) => {
  const date = new Date();
  return [
    {
      filterName: t('placement.profile.tabs.modificationsTab.placementHistoryFilters.modType'),
      name: PlacementHistoryFilterName.modType,
      type: FilterCompTypes.TYPEAHEADDROPDOWN,
      selectAllValue: 'All',
      options: modTypeOptions,
      isMultiSelect: true,
    },
    {
      filterName: t('placement.profile.tabs.modificationsTab.placementHistoryFilters.approvalStatus'),
      name: PlacementHistoryFilterName.approvalStatus,
      type: FilterCompTypes.TYPEAHEADDROPDOWN,
      options: approvalStatusOptions,
      isMultiSelect: true,
    },
    {
      filterName: t('placement.profile.tabs.modificationsTab.placementHistoryFilters.acceptanceStatus'),
      name: PlacementHistoryFilterName.acceptanceStatus,
      type: FilterCompTypes.TYPEAHEADDROPDOWN,
      options: acceptanceStatusOptions,
      isMultiSelect: true,
    },
    {
      filterName: t('placement.profile.tabs.modificationsTab.placementHistoryFilters.recruiterApproved'),
      name: PlacementHistoryFilterName.recruiterApproved,
      type: FilterCompTypes.TYPEAHEADDROPDOWN,
      options: recruiterApprovedOptions,
    },
    {
      filterName: t('placement.profile.tabs.modificationsTab.placementHistoryFilters.voidStatus'),
      name: PlacementHistoryFilterName.voidStatus,
      type: FilterCompTypes.TYPEAHEADDROPDOWN,
      options: voidStatusOptions,
    },
    {
      filterName: t('placement.profile.tabs.modificationsTab.placementHistoryFilters.activeMods'),
      name: PlacementHistoryFilterName.activeMods,
      type: FilterCompTypes.TYPEAHEADDROPDOWN,
      options: activeModsOptions,
      tooltipMessage: isFilterDisabled ? t('placement.profile.tabs.modificationsTab.placementHistoryFilters.tooltipMessage') : '',
      isDisabled : isFilterDisabled,
      isMultiSelect: true
    },
    {
      filterName: t('placement.profile.tabs.modificationsTab.placementHistoryFilters.effectiveDate'),
      name: PlacementHistoryFilterName.effectiveDate,
      type: FilterCompTypes.DATERANGEV2,
      variant: 'outlined',
      secondaryLabel: t('placement.profile.tabs.modificationsTab.placementHistoryFilters.effectiveDate'),
      useMaxWidth: true,
      maxWidth: 210,
      clickAway: true,
      disablePortal: true,
      definedRanges: [
        {
          label: 'Today',
          startDate: date,
          endDate: date,
          useLabelAsValue: false,
        },
        {
          label: 'This Week',
          startDate: startOfDay(getAmnStartOfWeek()),
          endDate: endOfDay(getAmnEndOfWeek()),
          useLabelAsValue: false,
        },
        {
          label: 'Next 13 weeks',
          startDate: startOfDay(date),
          endDate: endOfDay(addDays(date, 91)),
          useLabelAsValue: false,
        },
      ],
      minDate: new Date('01-01-1990')
    },
  ];
};

export const PlacementHistoryVisibilityModel = {
  type: true,
  description: true,
  standard: true,
  amount: true,
  acceptance: true,
  status: true,
  approvedBy: true,
  approvalDate: true,
  effectiveDate: true,
  task: true,
  recruiterApproved: true,
  byRecruiter: true,
  lastUpdated: true,
}
